module.exports = __webpack_public_path__ + "img/usdt.f119cea4.svg";